import * as React from "react";

function SvgDesktop(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}><path d="M14.5 2.4h-13c-.4 0-.8.3-.8.8v7c0 .4.3.8.8.8h5.8v1.3H5.6c-.4 0-.8.3-.8.8s.3.8.8.8h4.8c.4 0 .8-.3.8-.8s-.3-.8-.8-.8H8.8V11h5.8c.4 0 .8-.3.8-.8v-7c-.2-.5-.5-.8-.9-.8zm-.7 7H2.2V3.9h11.5v5.5z" /></svg>;
}

export default SvgDesktop;